import React from "react";

const JQuery_Certificate = () => {
  return (
    <div>
      <h1>JQuery_Certificate</h1>
      <p>Placeholder component for: "JQuery_Certificate"</p>
    </div>
  );
};

export default JQuery_Certificate;
